<script>
import { apiSecond } from '@/boot/axios'

import AqEmpty from '@/components/aqua/AqEmpty.vue'
import AqPageHeader from '@/components/aqua/AqPageHeader.vue'
import AqStatus from '@/components/aqua/AqStatus.vue'

export default {
	components: {
		AqEmpty,
		AqPageHeader,
		AqStatus,
	},
	props: {
		user: {
			type: Object,
		},
	},
	data() {
		return {
			applications: [],
			totalItems: null,
			loading: false,
			errorMessage: {
				status: null,
				text: null,
				messages: null,
			},
			message: {
				status: null,
				text: null,
			},
			blockElemet: null,
			unlockElemet: null,

			filters: {
				search: '',
			},
			options: {
				itemsPerPage: 10,
				page: 1,
			},

			filterCategories: null,

			headers: [
				{ text: '№', value: 'id', width: '72px' },
				{ text: this.$t('labels.subjectName'), value: 'name_company' },
				{ text: this.$t('labels.reportPeriod'), value: 'catch_at', sortable: false, width: '170px' },
				{ text: this.$t('headers.created_at'), value: 'created_at', width: '150px' },
				{ text: this.$t('headers.status'), value: 'status', width: '190px' },
				{
					text: '',
					value: 'action',
					align: 'end',
					sortable: false,
					width: '130px',
				},
			],
		}
	},
	computed: {
		orderList() {
			return ['subject_signed', 'tir_signed', 'rejected'].map((status) => ({
				status,
				name: this.$t('statusses.readGrownAllTir.' + status),
			}))
		},
		activeStatus() {
			return this.filterCategories?.status || null
		},
	},
	methods: {
		search() {
			this.options.page = 1
			this.pagination(this.options)
		},
		reset() {
			this.filters.search = ''
			this.filterCategories = null
			this.search()
		},
		selectStatus(option) {
			this.filterCategories = option
			this.search()
		},
		openRecord(item) {
			this.$router.push('/' + this.$i18n.locale + '/account/read-grown-all/' + item.id)
		},
		pagination(options) {
			this.apiGetUserDocumentList(options.page, options.itemsPerPage)
		},
		apiGetUserDocumentList(page = 1, per_page = 10) {
			const params = {
				...(this.filterCategories ? { status: this.filterCategories.status } : {}),
				page,
				per_page,
			}

			this.loading = true
			apiSecond
				.get(`/v1/grown/list`, {
					params,
				})
				.then((response) => {
					if (response.data) {
						this.applications = response.data.data
						this.totalItems = response.data.total
					}
				})
				.catch((error) => {
					if (error?.response?.status == 500) {
						this.errorMessage.status = 500
						this.errorMessage.text = this.$t('system_message.500')
					}
					if (error?.response?.status == 401) {
						this.errorMessage.status = 401
						this.errorMessage.text = error.response.data.error_message
						this.$router.push('/' + this.$i18n.locale + '/login')
					}
					if (error?.response?.status == 422) {
						this.errorMessage.status = 422
						this.errorMessage.text = error.response.data.error_message
					}
					if (error?.response?.status == 403) {
						this.errorMessage.status = 403
						this.errorMessage.text = error?.response?.data?.message
					}
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	beforeMount() {
		this.apiGetUserDocumentList()
	},
	beforeCreate() {
		if (!localStorage.token) {
			this.$router.push('/ru/login')
		}
	},
	head: {
		title() {
			return {
				inner: this.$t('sidebar.users_parent'),
			}
		},
		meta: [],
	},
}
</script>

<template>
	<div class="wrap__content aq-page" v-bind:class="{ 'wrap__content--preloader': !applications }">
		<v-preloader v-if="!applications" :message="errorMessage"></v-preloader>

		<div class="container" v-if="applications">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['ReadGrownAllManagement1']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content aq-shell">
							<AqPageHeader
								:title="$t('sidebar.aqua_report')"
								:eyebrow="$t('aqua.ui.grown.eyebrow')"
								:subtitle="$t('aqua.ui.grown.tir_hint')"
							/>

							<div class="aq-tabs" role="tablist" :aria-label="$t('headers.status')">
								<button
									type="button"
									role="tab"
									class="aq-tabs__item"
									:class="{ 'is-active': !activeStatus }"
									:aria-selected="String(!activeStatus)"
									@click="selectStatus(null)"
								>
									{{ $t('aqua.ui.grown.filter_all') }}
								</button>
								<button
									v-for="option in orderList"
									:key="option.status"
									type="button"
									role="tab"
									class="aq-tabs__item"
									:class="{ 'is-active': activeStatus === option.status }"
									:aria-selected="String(activeStatus === option.status)"
									@click="selectStatus(option)"
								>
									<span class="aq-tabs__dot" :class="`aq-tabs__dot--${option.status}`" aria-hidden="true"></span>
									{{ option.name }}
								</button>
							</div>

							<section class="aq-card aq-table">
								<v-data-table
									:headers="headers"
									:items="applications"
									:loading="loading"
									:options.sync="options"
									:server-items-length="totalItems"
									:footer-props="{
										'items-per-page-options': [5, 10, 20, 30, 40, 50],
									}"
									@update:options="pagination"
									@click:row="openRecord"
								>
									<template slot="item.id" slot-scope="{ item }">
										<span class="aq-table__id">{{ item.id }}</span>
									</template>
									<template v-slot:item.name_company="{ item }">
										<router-link
											:to="'/' + $i18n.locale + '/account/read-grown-all/' + item.id"
											class="aq-table__link"
											@click.native.stop
										>
											{{ item.user ? item.user.name_company : '—' }}
										</router-link>
										<span v-if="item.user && item.user.iin_bin" class="aq-table__muted">{{ item.user.iin_bin }}</span>
									</template>
									<template slot="item.catch_at" slot-scope="{ item }">
										{{ item.catch_at ? $options.filters.formatOnlyDate(item.catch_at) : '—' }}
									</template>
									<template v-slot:item.created_at="{ item }">
										<span class="aq-table__muted">{{ new Date(item.created_at).toLocaleDateString() }}</span>
									</template>
									<template v-slot:item.status="{ item }">
										<AqStatus
											v-if="item.status"
											:value="item.status"
											:label="$t('statusses.readGrownAllTir.' + item.status)"
										/>
										<span v-else class="aq-table__muted">—</span>
									</template>
									<template v-slot:item.action="{ item }">
										<router-link
											:to="'/' + $i18n.locale + '/account/read-grown-all/' + item.id"
											class="aq-btn aq-btn--sm"
											:class="item.status === 'subject_signed' ? 'aq-btn--primary' : 'aq-btn--ghost'"
											@click.native.stop
										>
											{{ item.status === 'subject_signed' ? $t('aqua.ui.grown.review') : $t('aqua.ui.grown.open') }}
										</router-link>
									</template>
									<template #no-data>
										<AqEmpty :title="$t('aqua.ui.grown.tir_empty_title')" :text="$t('aqua.ui.grown.tir_empty_text')">
											<button v-if="activeStatus" type="button" class="aq-btn" @click="reset">
												{{ $t('aqua.ui.grown.filter_all') }}
											</button>
										</AqEmpty>
									</template>
									<v-alert slot="no-results" :value="true" color="error">
										{{ $t('system_message.search') }}
									</v-alert>
								</v-data-table>
							</section>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.aq-shell {
	background: var(--aq-bg);
}
.aq-tabs {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 16px;
}
.aq-tabs__item {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	min-height: 44px;
	padding: 8px 18px;
	border: 1px solid var(--aq-border-strong);
	border-radius: 999px;
	background: var(--aq-surface);
	color: var(--aq-ink-2);
	font-size: 15px;
	font-weight: 500;
	transition: background 0.2s var(--aq-ease), border-color 0.2s var(--aq-ease), color 0.2s var(--aq-ease);
}
.aq-tabs__item:hover {
	border-color: var(--aq-primary);
	color: var(--aq-primary);
}
.aq-tabs__item:focus-visible {
	outline: none;
	box-shadow: 0 0 0 3px rgba(21, 127, 238, 0.25);
}
.aq-tabs__item.is-active {
	border-color: var(--aq-ink);
	background: var(--aq-ink);
	color: #fff;
}
.aq-tabs__dot {
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: var(--aq-primary);
}
.aq-tabs__dot--tir_signed {
	background: var(--aq-success);
}
.aq-tabs__dot--rejected {
	background: var(--aq-danger);
}
.aq-table {
	overflow: hidden;
}
.aq-table ::v-deep .v-data-table {
	background: transparent;
}
.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
	height: 46px;
	padding: 0 16px;
	border-bottom: 1px solid var(--aq-border) !important;
	background: #f7faff;
	color: var(--aq-muted) !important;
	font-size: 12px !important;
	font-weight: 600;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	white-space: nowrap;
}
.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
	height: 64px;
	padding: 10px 16px;
	border-bottom: 1px solid var(--aq-border) !important;
	color: var(--aq-ink);
	font-size: 15px;
}
.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr:not(.v-data-table__empty-wrapper) {
	cursor: pointer;
	transition: background 0.15s var(--aq-ease);
}
.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr:not(.v-data-table__empty-wrapper):hover {
	background: #f7faff !important;
}
.aq-table ::v-deep .v-data-table__empty-wrapper:hover {
	background: transparent !important;
}
.aq-table ::v-deep .v-data-footer {
	padding: 6px 12px;
	border-top: 0;
	color: var(--aq-muted);
}
.aq-table__id {
	color: var(--aq-muted);
	font-weight: 600;
}
.aq-table__link {
	display: block;
	color: var(--aq-ink);
	font-weight: 600;
	text-decoration: none;
}
.aq-table__link:hover,
.aq-table__link:focus-visible {
	color: var(--aq-primary);
	outline: none;
}
.aq-table__muted {
	color: var(--aq-muted);
	font-size: 14px;
}
.aq-btn--sm {
	min-height: 36px;
	padding: 6px 14px;
	font-size: 14px;
}
@media (max-width: 1280px) {
	.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
	.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
		width: auto !important;
		min-width: 0 !important;
		padding-right: 10px;
		padding-left: 10px;
	}
	.aq-table ::v-deep table > thead > tr > th:nth-child(1),
	.aq-table ::v-deep table > tbody > tr > td:nth-child(1),
	.aq-table ::v-deep table > thead > tr > th:nth-child(4),
	.aq-table ::v-deep table > tbody > tr > td:nth-child(4) {
		display: none;
	}
}
</style>
